export default "__VITE_ASSET__wSkVsJia__"